<template>
  <div class="mainPageDiv">

    <div class="pageHeader">
      User Information
    </div>

    <span class="subHeaderFont">Create New User:</span>

    <div @click="handleCreateRecord" 
        class="material-icons forIconNewRecord text-success" 
        data-tooltip="tooltip"
        title="Create a new User">
      add_card
    </div>

    <div class="radioheaderadjustment radioFirstLeftMargin">
      <input 
        type="radio" 
        id="radioActiveButtonID" 
        name="userState"
        @click="handleActiveRadioClick"
        @keydown.enter="handleActiveRadioClick"
        aria-label="Show Active Users"
        checked />

      <label class="lableMargin subHeaderFont" for="setup">Active</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin">
      <input 
              type="radio" 
              @click="handleAllRadioClick" 
                @keydown.enter="handleAllRadioClick"
              aria-label="Show All Users"
              id="radioAllButtonID" 
              name="userState"/>
      <label class="lableMargin subHeaderFont" for="setup">All</label>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <div class="gridSpacing">
      <ApplicationGrid :GridData="gridTime" RowsPerPageText="User Records" SearchText="Search User Records:"
        :EnablePaging="true" :EnableSearching="true" :EnableSorting="true" :HeaderArrays="headerArrays"
        :RowsPerPageArray="rowsPerPageArray" :EnableSettings="false" :EnableRecordsInfoDisplay="true">

        <!-- ------------------------------------------------------------------------ -->
        <!-- -------------- RIGHT Action (rightHeader11/rightData11) ---------------- -->
        <!-- ------------------------------------------------------------------------ -->

        <template v-slot:rightHeader11>
          <span class="actionsHeader">Edit</span>
        </template>

        <template v-slot:rightHeader10>
          <span class="actionsHeader">Create Date</span>
        </template>

        <template v-slot:rightData11="slotArgs">

          <span @click="handleEditRecord(slotArgs)" class="material-icons text-primary editIconSlot"
            data-tooltip="tooltip" title="Edit Record">
            edit
          </span>

        </template>

        
        <template v-slot:rightData10="slotArgs">

          <span>
            {{slotArgs.itemArg.createDate}}
            <span v-if="getNewDateYN(slotArgs.itemArg.createDate)" class="material-icons text-primary">
              fiber_new
            </span>
          </span>


        </template>

      </ApplicationGrid>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { store } from "../../../../store/store.js";
import ApplicationGrid from "../../../../components/dataSupport/ApplicationGrid.vue"

export default {
  data() {
    return {

      gridTime: { grid: null, time: null },
      rowsPerPageArray: [10, 25, 50, 100, 250],

      userState: 'active',

      headerArrays: [
        { defaultShow: true, rawName: 'userProfileId', displayName: 'User Profile ID', hoverText: 'Primary Key for User' },
        { defaultShow: false, rawName: 'userGUID', displayName: 'User GUID', hoverText: 'Primary Key for User' },
        { defaultShow: true, rawName: 'userName', displayName: 'User Name', hoverText: 'User Name' },
        { defaultShow: true, rawName: 'lastName', displayName: 'Last Name', hoverText: 'Last Name' },
        { defaultShow: true, rawName: 'firstName', displayName: 'First Name', hoverText: 'First Name' },
        { defaultShow: false, rawName: 'middleName', displayName: 'Middle Name', hoverText: 'Middle Name' },
        { defaultShow: true, rawName: 'email', displayName: 'Email', hoverText: 'Email' },
        { defaultShow: false, rawName: 'phone1', displayName: 'Phone', hoverText: 'Phone' },
        { defaultShow: false, rawName: 'title', displayName: 'Display Name', hoverText: 'Display Name' },
        { defaultShow: false, rawName: 'serviceRankId', displayName: 'Service Rank ID', hoverText: 'Service Rank ID' },
        { defaultShow: false, rawName: 'roleId', displayName: 'Role ID', hoverText: 'Role ID' },
        { defaultShow: false, rawName: 'redeployDate', displayName: 'Redeploy Date', hoverText: 'Redeploy Date' },
        { defaultShow: false, rawName: 'countryId', displayName: 'Country ID', hoverText: 'Country ID' },
        { defaultShow: false, rawName: 'companyId', displayName: 'Company ID', hoverText: 'Company ID' },
        { defaultShow: false, rawName: 'campLocationId', displayName: 'Camp Location ID', hoverText: 'Camp Location ID' },
        { defaultShow: true, rawName: 'userProfileNotes', displayName: 'User Profile Notes', hoverText: 'User Profile Notes' },
        { defaultShow: false, rawName: 'certificatCommonName', displayName: 'Certification Common Name', hoverText: 'Certification Common Name' },
        { defaultShow: false, rawName: 'deleted', displayName: 'Deleted', hoverText: 'Deleted' },
        { defaultShow: false, rawName: 'isActive', displayName: 'Is Active', hoverText: 'Is Active' },
        { defaultShow: false, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Update Date' },
        { defaultShow: false, rawName: 'createdBy', displayName: 'Created By', hoverText: 'Created By' },
        { defaultShow: false, rawName: 'updatedby', displayName: 'Updated By', hoverText: 'Updated By' },
      ],

      //leftHeader0,   ..., leftHeader9
      //rightHeader10, ..., rightHeader19
      leftRightSlots: [
        { slot: 'rightHeader11', enableSorting: true, field: '__not_specified__' },
      ],

    };
  },
  watch: {},
  created() {
    // console.log('**** created ****');
    this.getActiveUsers();
  },
  components: { ApplicationGrid },
  computed: {},
  methods: {

    getAllUsers() {
      axios
        .get(store.webAPIUrl + "UserProfile/SelAllUsers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          // console.log('this.$data.gridTime = ', this.$data.gridTime);
        });
    },

    getNewDateYN(date){
      date;
      var numDaysBetween = function(d1, d2) {
        var diff = (d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
      };

      var numDaysFromNow = numDaysBetween(new Date(date), new Date()); 
      //console.log(numDaysFromNow)
      if(numDaysFromNow < 0 && numDaysFromNow >= -10){
        return true;
      }
      return false; 
    },

    getActiveUsers() {
      axios
        .get(store.webAPIUrl + "UserProfile/SelAllActiveUsers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          // console.log('this.$data.gridTime = ', this.$data.gridTime);
        });
    },

    handleActiveRadioClick() {
      this.$data.userState = 'active';

      this.getActiveUsers();
    },

    handleAllRadioClick() {
      this.$data.userState = 'all';

      this.getAllUsers();
    },

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleEditRecord(args) {

      let userProfileId = args.itemArg["userProfileId"];
      let userGUID = args.itemArg["userGUID"];
      let firstName = args.itemArg["firstName"];
      let lastName = args.itemArg["lastName"];

      // console.log('handleEditRecord(): handleEditRecord: userProfileId = ', userProfileId);
      // console.log('handleEditRecord(): handleEditRecord: userGUID = ', userGUID);

      // console.log('userProfileId = ', args.itemArg["userProfileId"]);
      // console.log('userGUID = ', args.itemArg["userGUID"]);
      // console.log('userName = ', args.itemArg["userName"]);
      // console.log('lastName = ', args.itemArg["lastName"]);
      // console.log('firstName = ', args.itemArg["firstName"]);
      // console.log('userName = ', args.itemArg["userName"]);

      this.$router.push({
        name: 'editUser',
        params: {
          actionIsEdit: true,
          actionIsCreate: false,
          actionIsNonAdminEdit: false,
          userProfileIdParam: userProfileId,
          userGUIDParam: userGUID,
          lastNameParam: lastName
        }
      });
    },

    //This is called in response to clicking create new user.
    handleCreateRecord(args) {

      // console.log('handleEditRecord(): handleEditRecord: userProfileId = ', userProfileId);
      // console.log('handleEditRecord(): handleEditRecord: userGUID = ', userGUID);

      // console.log('userProfileId = ', args.itemArg["userProfileId"]);
      // console.log('userGUID = ', args.itemArg["userGUID"]);
      // console.log('userName = ', args.itemArg["userName"]);
      // console.log('lastName = ', args.itemArg["lastName"]);
      // console.log('firstName = ', args.itemArg["firstName"]);
      // console.log('userName = ', args.itemArg["userName"]);

      this.$router.push({
        name: 'editUser',
        params: {
          actionIsEdit: false,
          actionIsCreate: true,
          actionIsNonAdminEdit: false,
          userProfileIdParam: -1,
          userGUIDParam: 'empty',
          lastNameParam: 'empty'
        }
      });
    },
  },
};
</script>

<style scoped>

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.subHeaderFont {
  font-size: 18px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.pageHeader {
  font-size: 24px;
  margin-bottom: 30px;
}

.gridSpacing {
  margin-right: 10px;
  margin-left: 10px;

}
</style>
